import "./Productlist.css";
import Product from "../Product/Product";

import pro1 from "../../img/jinkal.png";
import pro2 from "../../img/dhruvi.png"
import pro3 from "../../img/mithil.png"


const Productlist = () => {
    return (
        <div   className="pl">
            <div className="pl-texts">
        <h1 className="pl-title">MY Projects</h1>
        <p className="pl-desc">
        i make using reacr js and css make webapp .
        </p>
 

 < div   className="pl-list"> 
 
<Product  img={pro1}     link = "https://keen-hoover-d1672d.netlify.app"/>
<Product   img={pro2}                            link="https://silly-yalow-36dd79.netlify.app"/>
<Product   img ={pro3}     link= "https://blissful-jones-d8bceb.netlify.app/" />
 </div>






</div>








        </div>
    );
};

export default Productlist;

